import React from 'react';
import styled from 'styled-components';
import { Spotlight } from 'api/spotlight/types';
import { ReactComponent as SpotlightIcon } from 'assets/svgs/spotlight-inverse.svg';

interface Props {
  spotlight: Spotlight;
}

const Wrapper = styled.div`
  width: 100%;
  padding: var(--cp-spacing-05);
  background: #f7ae58;
  border-radius: var(--border-radius-small);
  display: flex;
  align-items: start;
  justify-content: start;
  position: relative;
  svg {
    margin-top: var(--cp-spacing-02);
  }
`;

const Content = styled.div`
  margin-left: var(--spacing-05);
  width: 100%;
`;

export const SpotlightForTaskDrawer: React.FC<Props> = ({ spotlight }) => {
  return (
    <Wrapper>
      <SpotlightIcon />
      <Content>{spotlight.caption}</Content>
    </Wrapper>
  );
};
